import { useState, useRef } from "react";
import { ChevronDown } from "lucide-react";
import useResizeMeasure from "@/hooks/useResizeMeasure";

export default function Accordion({
    title,
    subHeader = null,
    children,
    maxHeight = "",
    isOpen: controlledOpen,
    defaultOpen = false,
    onToggle,
    closetext = null,
    opentext = null,
    className = "",
    headerClassName = "",
    titleClassName = "",
    buttonClassName = '',
    contentClassName = "",
    iconClassname = "text-jmt-primary-800",
    icon = <ChevronDown className="w-4 h-4 lg:w-5 lg:h-5" />
}) {
    const [internalOpen, setInternalOpen] = useState(defaultOpen);

    const isExpanded = controlledOpen !== undefined ? controlledOpen : internalOpen;
    const contentRef = useRef(null);
    const innerRef = useRef(null);

    const has_max_height =
        maxHeight !== "" && maxHeight !== null && maxHeight !== undefined;

    const [contentHeight, setContentHeight] = useState(0);

    // اندازه فقط در ResizeObserver مشترک خوانده می‌شود (useResizeMeasure): اولین callback آن همان اندازه‌گیری اولیه است؛
    // خواندن مستقیم در افکت، یا بعد از نوشتن متغیرهای هدر در observer جدا، layout اجباری می‌ساخت
    useResizeMeasure(
        () => (has_max_height ? [] : [innerRef.current]),
        () => {
            const node = innerRef.current;
            if (!node) return;
            setContentHeight(Math.ceil(Math.max(node.scrollHeight, node.getBoundingClientRect().height)) + 4);
        },
        [has_max_height, children]
    );

    const handleToggle = () => {
        if (onToggle) {
            onToggle(!isExpanded);
        } else {
            setInternalOpen(!isExpanded);
        }
    };

    const expanded_height = has_max_height ? maxHeight : `${contentHeight}px`;

    return (
        <div className={className}>
            <button
                type="button"
                onClick={handleToggle}
                aria-expanded={isExpanded}
                className={`cursor-pointer ${headerClassName} ${buttonClassName}`} >
                <div className={titleClassName}>
                    {title}
                </div>

                <div className="flex items-center justify-between gap-1 shrink-0">
                    {isExpanded ?
                        <span className="font-bold text-xs lg:text-sm text-jmt-primary-800"> {closetext}</span>
                        : <span className="font-bold text-xs lg:text-sm text-jmt-primary-800"> {opentext}</span>
                    }
                    <div className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""} ${iconClassname}`}>
                        {icon}
                    </div>
                </div>
            </button>

            {/* یک خط کمکی زیر هدر که همیشه دیده می‌شود و باز/بسته شدن آکاردیون را تغییر نمی‌دهد */}
            {subHeader}

            {/* Body */}
            <div
                ref={contentRef}
                style={{
                    maxHeight: isExpanded ? expanded_height : 0,
                }}
                className="transition-all duration-300 ease-in-out overflow-hidden"
            >
                <div
                    ref={innerRef}
                    style={has_max_height ? { maxHeight } : undefined}
                    className={`${has_max_height ? "overflow-y-auto" : ""} ${contentClassName}`.trim() || undefined}
                >
                    {children}
                </div>
            </div>
        </div>
    );
}
